// Phone auth remains opt-in while SMS delivery is being verified.
const phoneEnabledFlag = import.meta.env.VITE_ENABLE_PHONE_AUTH === "true";
const googleEnabledFlag = import.meta.env.VITE_ENABLE_GOOGLE_AUTH !== "false";

export const useAuthProviders = () => ({
  isGoogleEnabled: googleEnabledFlag,
  isAppleEnabled: false,
  isPhoneEnabled: phoneEnabledFlag,
  isEmailEnabled: true,
});

export const getAuthProviderStatus = () => ({
  isGoogleEnabled: googleEnabledFlag,
  isAppleEnabled: false,
  isPhoneEnabled: phoneEnabledFlag,
  isEmailEnabled: true,
});
